
import { defineComponent } from "vue";
export default defineComponent({
  name: "arrow-down-icon"
});
